// Page d'accueil du site public : assemble les sections (src/pages/home/).
// Spec : docs/superpowers/specs/2026-10-10-refonte-site-public-design.md
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "./home/Hero";
import BandeConfiance from "./home/BandeConfiance";
import ChapitreSportif from "./home/ChapitreSportif";
import ChapitreCoach from "./home/ChapitreCoach";
import Tarifs from "./home/Tarifs";
import Faq from "./home/Faq";
import AppelFinal from "./home/AppelFinal";

function Home() {
	const { hash } = useLocation();

	// Arrivée par un lien du pied de page (/#tarifs…) : le navigateur cherche
	// l'ancre avant que la page soit rendue, on la rejoint une fois montée.
	useEffect(() => {
		if (!hash) return;
		const cible = document.getElementById(hash.slice(1));
		if (cible) cible.scrollIntoView();
	}, [hash]);

	return (
		<>
			<Hero />
			<BandeConfiance />
			<ChapitreSportif />
			<ChapitreCoach />
			<Tarifs />
			<Faq />
			<AppelFinal />
		</>
	);
}

export default Home;
